"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[608],{

/***/ 6067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ HoneyPot_HoneyPot; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/HoneyPot/HoneyPot.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var HoneyPot = function HoneyPot(_ref) {
  var register = _ref.register,
      _onChange = _ref.onChange;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "absolute -left-[500px]",
    "aria-hidden": "true",
    style: {
      zIndex: -1
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: "user_code"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
      type: "text",
      id: "user_code",
      name: "user_code",
      autoComplete: "off",
      placeholder: "User Code"
    }, register('user_code', {
      onChange: function onChange(e) {
        return _onChange(e);
      }
    })))]
  });
};

/* harmony default export */ var HoneyPot_HoneyPot = (HoneyPot);
;// CONCATENATED MODULE: ./components/HoneyPot/index.ts


/***/ }),

/***/ 7117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* reexport */ PDPAConsent_PDPAConsent; },
  "S": function() { return /* reexport */ initialPDPAInfoPayload; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Contexts/LocaleContext.tsx
var LocaleContext = __webpack_require__(5314);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/_OldDesign/PDPAConsent/PDPAConsent.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var PDPAConsent = function PDPAConsent(_ref) {
  var choices = _ref.choices,
      payload = _ref.payload,
      setPayload = _ref.setPayload,
      valid = _ref.valid,
      setValid = _ref.setValid,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$newDesign = _ref.newDesign,
      newDesign = _ref$newDesign === void 0 ? false : _ref$newDesign;

  var _useState = (0,react.useState)({
    'PP-1': false,
    'PP-2': false,
    'PP-3': false,
    'PP-4': false,
    'PP-5': false
  }),
      uiCheckbox = _useState[0],
      setUICheckbox = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showSendBy = _useState2[0],
      setShowSendBy = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      consent = _useState3[0],
      setConsent = _useState3[1];

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  (0,react.useEffect)(function () {
    // update uiCheck when payload updated
    var purposes = payload === null || payload === void 0 ? void 0 : payload.purposes;
    if (!purposes) return;
    var updated = {};
    purposes.forEach(function (p) {
      updated[p.purpose] = p.consented;
    });
    setUICheckbox(_objectSpread(_objectSpread({}, uiCheckbox), updated)); // validate form

    var allFalse = purposes.every(function (p) {
      return !p.consented;
    });

    if (allFalse) {
      setValid(false);
      return;
    }

    var selectSomeSendBy = purposes.filter(function (p) {
      return ['PP-4', 'PP-5'].includes(p.purpose);
    }).some(function (p) {
      return p.consented;
    });
    setValid(selectSomeSendBy);
  }, [payload]);

  var toggleCheckbox = function toggleCheckbox(checkedType, allConsent) {
    var purposes = payload.purposes;
    purposes = purposes.map(function (p) {
      if (p.purpose !== checkedType) return p;

      if (allConsent !== undefined) {
        p.consented = allConsent;
      } else {
        p.consented = !p.consented;
      }

      return p;
    });
    setPayload(_objectSpread(_objectSpread({}, payload), {}, {
      purposes: purposes
    }));
  };

  var handleSelectChoice = function handleSelectChoice(checkedType) {
    var _payload$purposes, _payload$purposes2;

    toggleCheckbox(checkedType);
    var isCheckedSomeChoices = ((_payload$purposes = payload === null || payload === void 0 ? void 0 : payload.purposes) !== null && _payload$purposes !== void 0 ? _payload$purposes : []).filter(function (p) {
      return choices.includes(p.purpose);
    }).some(function (p) {
      return p.consented;
    });

    if (isCheckedSomeChoices) {
      autoSelectSendByEmail();
      return;
    }

    var noCheckedAnyChoices = ((_payload$purposes2 = payload === null || payload === void 0 ? void 0 : payload.purposes) !== null && _payload$purposes2 !== void 0 ? _payload$purposes2 : []).filter(function (p) {
      return choices.includes(p.purpose);
    }).every(function (p) {
      return !p.consented;
    });

    if (noCheckedAnyChoices) {
      clearAllCheck();
    }
  };

  var handleSelectConsent = function handleSelectConsent(checked) {
    setConsent(checked);
    payload.purposes.forEach(function (p) {
      toggleCheckbox(p.purpose, checked);
    });
  };

  var handleSelectSendBy = function handleSelectSendBy(checkedType) {
    toggleCheckbox(checkedType);
  };

  var autoSelectSendByEmail = function autoSelectSendByEmail() {
    var purposes = payload.purposes;
    var alreadySelectSomeSendBy = purposes.filter(function (p) {
      return ['PP-4', 'PP-5'].includes(p.purpose);
    }).some(function (p) {
      return p.consented;
    });

    if (alreadySelectSomeSendBy) {
      return;
    }

    purposes = purposes.map(function (p) {
      if (p.purpose !== 'PP-4') return p;
      p.consented = true;
      return p;
    });
    setPayload(_objectSpread(_objectSpread({}, payload), {}, {
      purposes: purposes
    }));
    setShowSendBy(true);
  };

  var clearAllCheck = function clearAllCheck() {
    var purposes = payload.purposes;
    purposes = purposes.map(function (p) {
      p.consented = false;
      return p;
    });
    setPayload(_objectSpread(_objectSpread({}, payload), {}, {
      purposes: purposes
    }));
    setShowSendBy(false);
  };

  if (newDesign) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        className: "flex mb-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-4 h-4",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            id: "pdpa-consent",
            type: "checkbox",
            checked: consent,
            className: "cursor-pointer",
            onChange: function onChange(e) {
              return handleSelectConsent(e.target.checked);
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "ml-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "pdpa-consent",
            className: "cursor-pointer",
            children: lang === 'en' ? 'I agree to be contacted by CODIUM regarding relevant products or services. See our' : 'ข้าพเจ้ายินยอมให้โคเดียมติดต่อและนำเสนอผลิตภัณฑ์หรือบริการที่เหมาะสม โดยสามารถอ่านเพิ่มเติมได้ที่'
          }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: '/privacy-policy',
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              target: "_blank",
              className: " text-lightBlue underline cursor-pointer hover:text-lightBlue-600",
              children: lang === 'en' ? 'Privacy Policy.' : 'นโยบายความเป็นส่วนตัว'
            })
          })]
        })]
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
        children: "\u0E42\u0E04\u0E40\u0E14\u0E35\u0E22\u0E21\u0E2A\u0E31\u0E0D\u0E0D\u0E32\u0E27\u0E48\u0E32\u0E08\u0E30\u0E43\u0E2B\u0E49\u0E04\u0E27\u0E32\u0E21\u0E04\u0E38\u0E49\u0E21\u0E04\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }), ' ', "\u0E41\u0E25\u0E30\u0E40\u0E23\u0E32\u0E08\u0E30\u0E43\u0E0A\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E17\u0E48\u0E32\u0E17\u0E35\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E19\u0E33\u0E40\u0E2A\u0E19\u0E2D\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C/\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E23\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E21\u0E32\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0E43\u0E19\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E13\u0E35\u0E40\u0E23\u0E32\u0E2D\u0E32\u0E08\u0E08\u0E30\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E2B\u0E32\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E19\u0E33\u0E40\u0E2A\u0E19\u0E2D\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C, \u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23 \u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E34\u0E08\u0E01\u0E23\u0E23\u0E21\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E16\u0E49\u0E32\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E40\u0E23\u0E32\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E43\u0E2B\u0E49\u0E04\u0E27\u0E32\u0E21\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21\u0E01\u0E31\u0E1A\u0E40\u0E23\u0E32\u0E43\u0E19\u0E01\u0E23\u0E13\u0E35\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      children: choices.map(function (choice) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "py-2 flex items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            id: choice,
            type: "checkbox",
            checked: uiCheckbox[choice],
            onChange: function onChange() {
              return handleSelectChoice(consentPurposeDetail[choice].value);
            },
            className: "cursor-pointer"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: choice,
            className: "ml-4 cursor-pointer",
            children: consentPurposeDetail[choice].label
          })]
        }, choice);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), showSendBy ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E40\u0E23\u0E32\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E04\u0E38\u0E13"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "flex space-x-28",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "flex items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            id: "byEmail",
            type: "checkbox",
            checked: uiCheckbox['PP-4'],
            onChange: function onChange() {
              return handleSelectSendBy('PP-4');
            },
            className: "cursor-pointer"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "byEmail",
            className: "ml-4 cursor-pointer",
            children: consentPurposeDetail['PP-4'].label
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "flex items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            id: "byPhone",
            type: "checkbox",
            checked: uiCheckbox['PP-5'],
            onChange: function onChange() {
              return handleSelectSendBy('PP-5');
            },
            className: "cursor-pointer"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "byPhone",
            className: "ml-4 cursor-pointer",
            children: consentPurposeDetail['PP-5'].label
          })]
        })]
      }), !valid ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mt-2 text-red font-medium",
        children: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D"
      }) : null]
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      className: "".concat(mode === 'dark' ? 'text-white' : 'text-neutral-600'),
      children: ["* \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E16\u0E2D\u0E19\u0E04\u0E27\u0E32\u0E21\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E17\u0E38\u0E01\u0E40\u0E21\u0E37\u0E48\u0E2D \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E16\u0E2D\u0E19\u0E04\u0E27\u0E32\u0E21\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21 \u0E41\u0E25\u0E30\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E01\u0E32\u0E23\u0E04\u0E49\u0E38\u0E21\u0E04\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E48\u0E32\u0E19\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: '/privacy-policy',
        passHref: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          target: "_blank",
          className: " text-lightBlue underline cursor-pointer hover:text-lightBlue-600",
          children: "\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E28\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32"
        })
      })]
    })]
  });
};

/* harmony default export */ var PDPAConsent_PDPAConsent = (PDPAConsent);
var consentPurposeDetail = {
  'PP-1': {
    label: 'เพื่อการวิเคราะห์และนำเสนอผลิตภัณฑ์บริการที่ฉันอาจสนใจ',
    value: 'PP-1'
  },
  'PP-2': {
    label: 'เพื่อการเชิญฉันเข้าร่วมกิจกรรม/งานสัมมนาที่ฉันอาจสนใจ',
    value: 'PP-2'
  },
  'PP-3': {
    label: 'เพื่อรับข่าวสารความรู้ใหม่ๆ ที่น่าสนใจจากโคเดียม',
    value: 'PP-3'
  },
  'PP-4': {
    label: 'อีเมล',
    value: 'PP-4'
  },
  'PP-5': {
    label: 'โทรศัพท์',
    value: 'PP-5'
  }
};
;// CONCATENATED MODULE: ./components/_OldDesign/PDPAConsent/PDPAConsent.utils.ts
var initialPDPAInfoPayload = function initialPDPAInfoPayload(customerCode, note) {
  return {
    customer_code: customerCode,
    purposes: [{
      purpose: 'PP-1',
      consented: false,
      note: note
    }, {
      purpose: 'PP-2',
      consented: false,
      note: note
    }, {
      purpose: 'PP-3',
      consented: false,
      note: note
    }, {
      purpose: 'PP-4',
      consented: false,
      note: note
    }, {
      purpose: 'PP-5',
      consented: false,
      note: note
    }]
  };
};
;// CONCATENATED MODULE: ./components/_OldDesign/PDPAConsent/index.ts



/***/ }),

/***/ 954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IE": function() { return /* binding */ findContent; },
/* harmony export */   "Iu": function() { return /* binding */ translate; },
/* harmony export */   "OC": function() { return /* binding */ filterContent; },
/* harmony export */   "n7": function() { return /* binding */ translate2; },
/* harmony export */   "pF": function() { return /* binding */ findContentByTitle; },
/* harmony export */   "rT": function() { return /* binding */ titleOnly; }
/* harmony export */ });
var translate = function translate(item, name, lang) {
  if (!item) return;
  var translated = lang === 'en' ? item[name] : item["".concat(name, "TH")];
  return translated ? translated : item[name];
};
var titleOnly = function titleOnly(item) {
  if (!item) return;
  var titleItem = JSON.parse(JSON.stringify(item));
  delete titleItem.subContent;
  return titleItem;
};
var findContent = function findContent(data, name) {
  return data === null || data === void 0 ? void 0 : data.find(function (item) {
    return item.name === name;
  });
};
var findContentByTitle = function findContentByTitle(data, name) {
  return data === null || data === void 0 ? void 0 : data.find(function (item) {
    return item.title === name;
  });
};
var filterContent = function filterContent(data, name) {
  return data === null || data === void 0 ? void 0 : data.filter(function (item) {
    return item.name === name;
  });
};
var translate2 = function translate2(th, en, lang) {
  return lang === 'en' ? en : th;
};

/***/ }),

/***/ 1672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jU": function() { return /* binding */ formatRules; },
/* harmony export */   "n0": function() { return /* binding */ requiredRule; }
/* harmony export */ });
/* unused harmony exports EMAIL_PATTERN, PHONE_SEPARATOR_PATTERN, PHONE_PATTERN, isValidEmail, isValidPhone, emailMessage, phoneMessage */
/* harmony import */ var utils_translate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(954);

var EMAIL_PATTERN = /^\S+@\S+\.\S+$/; // Phone numbers are typed in every shape people are used to — 081-234-5678,
// (02) 123 4567, +66 81 234 5678 — so the separators are stripped before the
// digit count is checked. The value itself is never rewritten: what the user
// typed is what gets stored.

var PHONE_SEPARATOR_PATTERN = /[\s\-.()]/g;
var PHONE_PATTERN = /^\+?\d{9,15}$/;
var isValidEmail = function isValidEmail(value) {
  return EMAIL_PATTERN.test(String(value !== null && value !== void 0 ? value : '').trim());
};
var isValidPhone = function isValidPhone(value) {
  return PHONE_PATTERN.test(String(value !== null && value !== void 0 ? value : '').replace(PHONE_SEPARATOR_PATTERN, ''));
};
var emailMessage = function emailMessage(lang) {
  return (0,utils_translate__WEBPACK_IMPORTED_MODULE_0__/* .translate2 */ .n7)('รูปแบบของ Email ไม่ถูกต้อง กรุณากรอก Email ให้ถูกต้อง', 'Invalid email format. Please enter a valid email.', lang);
};
var phoneMessage = function phoneMessage(lang) {
  return (0,utils_translate__WEBPACK_IMPORTED_MODULE_0__/* .translate2 */ .n7)('รูปแบบของหมายเลขโทรศัพท์ไม่ถูกต้อง กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง', 'Invalid phone number format. Please enter a valid phone number.', lang);
};
var EMAIL_FIELDS = ['email'];
var PHONE_FIELDS = ['phone', 'phoneNumber', 'tel'];
/**
 * react-hook-form rules for a field, keyed by its name.
 *
 * Forms are driven by field lists that come from Strapi, so the field name is
 * the only thing available to decide what a value should look like. Returns an
 * empty object for names that need no format check, which makes it safe to
 * spread into every `register()` call.
 *
 * Phone uses `validate` rather than `pattern` because the separators have to be
 * stripped before the digits are counted, which a single regex cannot express.
 */

var formatRules = function formatRules(fieldName, lang) {
  if (EMAIL_FIELDS.includes(fieldName)) {
    return {
      validate: function validate(value) {
        return !value || isValidEmail(value) || emailMessage(lang);
      }
    };
  }

  if (PHONE_FIELDS.includes(fieldName)) {
    return {
      validate: function validate(value) {
        return !value || isValidPhone(value) || phoneMessage(lang);
      }
    };
  }

  return {};
};

/**
 * react-hook-form `required` rule with the message every form uses:
 * "กรุณากรอก <label>" / "Please enter your <label>".
 */
var requiredRule = function requiredRule(required, label, lang) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$possessive = _ref.possessive,
      possessive = _ref$possessive === void 0 ? true : _ref$possessive,
      _ref$lowercase = _ref.lowercase,
      lowercase = _ref$lowercase === void 0 ? true : _ref$lowercase;

  var text = label !== null && label !== void 0 ? label : '';
  return {
    required: {
      value: required,
      message: "".concat((0,utils_translate__WEBPACK_IMPORTED_MODULE_0__/* .translate2 */ .n7)('กรุณากรอก', possessive ? 'Please enter your' : 'Please enter', lang), " ").concat(lowercase ? text.toLowerCase() : text)
    }
  };
};

/***/ })

}]);